import * as React from 'react';
// import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { Grid } from '@mui/material';
import VendorStepForm from './Form';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AddVendorForm(props) {
  return (
    <React.Fragment>
      <Dialog fullScreen open={props.open} onClose={props.handleClose} TransitionComponent={Transition}>
        <AppBar sx={{ position: 'sticky', top: '0px', backgroundColor: '#592375', boxShadow: 'none', height: 'fit-content' }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h4" component="div" color="#fff">
              Network
              <br /> Manager
            </Typography>

            <IconButton edge="start" color="#252525" onClick={props.handleClose} aria-label="close">
              <CloseIcon sx={{ color: '#fff' }} />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Grid container padding={2} justifyContent="center">
          <Grid item xs={8}>
            <VendorStepForm />
          </Grid>
        </Grid>
      </Dialog>
    </React.Fragment>
  );
}
